// @flow
import React from 'react'

export function Star (props: {
  i: number,
  inverted: boolean,
  events: {
    [string]: (number) => void
  },
  starColor: any,
  starClass: string
}) {
  let updatedEvents = {}

  Object.entries(props.events).forEach(
    (handler: [string, (number) => void]) => {
      updatedEvents[handler[0]] = event => {
        event.preventDefault()
        event.stopPropagation()
        handler[1](props.i)
      }
    }
  )

  return (
    <i className='ui icons' {...updatedEvents}><i
      className={`${props.starColor} ${
        props.inverted ? 'inverted' : ''
        } outline star icon`}
    /><i
      className={`${props.starColor} ${props.inverted ? 'inverted' : ''} ${
        props.starClass
        } star icon`}
    /></i>
  )
}
